import React from 'react';
import _ from 'lodash';
import { Box, Drawer, Tooltip, Fab, List, Stack } from '@mui/material';
import { useQuery } from 'react-fetching-library';
import { useSelector } from 'react-redux';
import AddIcon from '@mui/icons-material/Add';
import { DebounceInput } from 'react-debounce-input';
import AdapterDateFns from '@mui/lab/AdapterDateFns';
import LocalizationProvider from '@mui/lab/LocalizationProvider';
import DatePicker from '@mui/lab/DatePicker';

import { useResponsive } from '../../../../services/hooks';
import { NAVBAR } from '../../../../utils/config';
import { getPromotionPredefinedFilters } from '../../../../services/request';
import { FilterTree } from './availability-status-details/FilterTree';
import Scrollbar from '../../../../components/Scrollbar';
import { CssTextField } from '../../../../components/others/CssTextField';
import { formatDate } from '../../../../services/functions';

export const AvailabilityStatusSidebar = props => {
  const { isOpenSidebar, onCloseSidebar, createSignal, queryCallback } = props;
  const { season } = useSelector(state => state.app);
  const filtersRef = React.useRef();
  const predefinedFilters = useQuery(getPromotionPredefinedFilters(season, 'Filtry'));
  const isDesktop = useResponsive('up', 'md');
  const [treeObjects, setTreeObjects] = React.useState({});
  const [description, setDescription] = React.useState('');
  const [dateFrom, setDateFrom] = React.useState(null);
  const [dateTo, setDateTo] = React.useState(null);

  React.useEffect(() => {
    if (!predefinedFilters.error && !predefinedFilters.loading) {
      setTreeObjects(predefinedFilters.payload);
    }
  }, [season, predefinedFilters.loading]);

  React.useEffect(() => {
    if (filtersRef && filtersRef.current) {
      let search = '';
      const tree = filtersRef.current.getTree();
      if (!_.isEmpty(tree)) {
        search += `tree=${tree}&`;
      }
      if (!_.isEmpty(description)) {
        search += `description=${description}&`;
      }
      const formattedDateFrom = formatDate(dateFrom);
      const formattedDateTo = formatDate(dateTo);
      if (formattedDateFrom) {
        search += `date_from_from=${formattedDateFrom}&`;
      }
      if (formattedDateTo) {
        search += `date_to_to=${formattedDateTo}&`;
      }
      queryCallback(search || null);
    }
  }, [description, dateFrom, dateTo]);

  const filterCallback = selectedTree => {
    let search = '';
    if (selectedTree !== 'tree=') {
      search += `${selectedTree}&`;
    }
    if (!_.isEmpty(description)) {
      search += `description=${description}&`;
    }
    const formattedDateFrom = formatDate(dateFrom);
    const formattedDateTo = formatDate(dateTo);
    if (formattedDateFrom) {
      search += `date_from_from=${formattedDateFrom}&`;
    }
    if (formattedDateTo) {
      search += `date_to_to=${formattedDateTo}&`;
    }
    queryCallback(search || null);
  };

  const renderContent = (
    <Scrollbar sx={{ opacity: predefinedFilters.loading ? '0.5' : '1' }}>

      <Box sx={{ p: 1 }}>
        <Box display="flex" justifyContent="center">
          <Tooltip title="Dodaj status dostępności" sx={{ mb: 4 }}>
            <Fab
              color="primary"
              aria-label="add"
              onClick={() => {
                createSignal();
              }}
            >
              <AddIcon style={{ fontSize: '30px' }} />
            </Fab>
          </Tooltip>
        </Box>
        <DebounceInput
          debounceTimeout={1000}
          sx={{ width: 200, mb: 2 }}
          element={CssTextField}
          placeholder="Opis statusu..."
          onChange={e => setDescription(e.target.value)}
          variant="standard"
        />
        <LocalizationProvider dateAdapter={AdapterDateFns}>
          <Stack direction="column" alignItems="flex-start" spacing={1} sx={{ mb: 2 }}>
            <DatePicker
              inputFormat="yyyy-MM-dd"
              mask="____-__-__"
              autoOk
              label="Data od"
              value={dateFrom}
              onChange={val => setDateFrom(val)}
              renderInput={params => <CssTextField variant="standard" {...params} />}
            />
            <DatePicker
              inputFormat="yyyy-MM-dd"
              mask="____-__-__"
              autoOk
              label="Data do"
              value={dateTo}
              onChange={val => setDateTo(val)}
              renderInput={params => <CssTextField variant="standard" {...params} />}
            />
          </Stack>
        </LocalizationProvider>
        <List disablePadding>
          {!_.isEmpty(treeObjects)
            ? <FilterTree data={treeObjects} ref={filtersRef} initSelected={[]} filterCallback={filterCallback} />
            : null
          }
        </List>
      </Box>
    </Scrollbar>
  );

  return (
    <>
      {isDesktop ? (
        <Drawer variant="permanent" PaperProps={{ sx: { width: NAVBAR.BASE_WIDTH + 20, position: 'relative' } }}>
          {renderContent}
        </Drawer>
      ) : (
        <Drawer
          open={isOpenSidebar}
          onClose={onCloseSidebar}
          ModalProps={{ keepMounted: true }}
          PaperProps={{ sx: { width: NAVBAR.BASE_WIDTH } }}
        >
          {renderContent}
        </Drawer>
      )}
    </>
  );
};
